export default __webpack_public_path__ + "static/media/img-error-bg-dark.b299d608.svg";